import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Landing from '../../pages/index';

export default function LandingRouter() {
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
        </Routes>
    );
}
